import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  SESSIONS_PAGE_URL,
  GALLERY_PAGE_URL,
} from '../../utils/Routes';
import { CompanyName } from '../../utils/Constants';

function CallToActionLearnMore() {
  const buttons = [
    {
      text: 'My Services',
      link: SESSIONS_PAGE_URL,
      ariaLabel: `Learn about submission to ${CompanyName}`,
    },
    {
      text: 'Gallery',
      link: GALLERY_PAGE_URL,
      ariaLabel: `Explore ${CompanyName}’s gallery`,
    },
  ];

  return (
    <section className='grid h-fit px-8 sm:px-10 md:px-20 lg:px-32 max-w-4xl w-full mx-auto'>
      <div className='grid neon-border px-2 py-2 rounded overflow-hidden'>
        <header className='text-center py-6'>
          <h2 className='font-titleFont neon_text_heavy_redpink text-3xl md:text-4xl tracking-wider drop-shadow-lg'>
            LEARN MORE & SEE MORE
          </h2>
        </header>

        <div className='grid gap-y-2 md:grid-flow-col gap-x-8 bg-colour2 font-titleFont rounded overflow-hidden p-8'>
          {buttons.map((btn, index) => (
            <Link
              key={index}
              to={btn.link}
              className={`cursor-pointer ${
                index === 0
                  ? 'border-colour7'
                  : 'border-colour5'
              } hover:bg-colour5/50 border-2 border-solid text-xl border-colour1 bg-black w-full text-center h-fit px-10 md:px-2 lg:px-6 py-2 rounded mx-auto`}
              aria-label={btn.ariaLabel}
            >
              {btn.text}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CallToActionLearnMore;
